import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

let loggedIn = false;

class APIService {
  fetchAllInstances(entity, metrcKey) {
    // entity = 'entity/';
    const url = API_URL + entity + '?metrc_id=' + metrcKey;
    return axiosInstance().get(url);
  }

  fetchInstance(entityWithID) {
    const url = API_URL + entityWithID;
    return axiosInstance().get(url);
  }

  createInstance(entity, payload) {
    // entity = 'entity/';
    const url = API_URL + entity;
    return axiosInstance().post(url, payload);
  }

  modifyInstance(entityWithID, payload) {
    // entityWithID = 'entity/entityID/';
    const url = API_URL + entityWithID;

    return axiosInstance().put(url, payload);
  }

  patchInstance(entity, payload) {
    const url = `${API_URL}${entity}`;
    return axiosInstance().patch(url, payload);
  }

  deleteInstance(entityWithID, payload) {
    // entityWithID = 'entity/entityID/';
    const url = API_URL + entityWithID;

    const token = localStorage.getItem('token');

    return axiosInstance().delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // "Authorization": `Basic ${encodedAuth}`
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
  }
}
export default new APIService();
